/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Description_Import_SuccessInputs */

const en_scene_description_import_success = /** @type {(inputs: Scene_Description_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shot descriptions imported successfully. Two Event Groups have been added: Dialogue and Shot Changes.`)
};

const fr_scene_description_import_success = /** @type {(inputs: Scene_Description_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les descriptions des plans ont été importées avec succès. Deux groupes d'événements ont été ajoutés : Dialogue et Changements de plan.`)
};

const de_scene_description_import_success = /** @type {(inputs: Scene_Description_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Shot-Beschreibungen wurden erfolgreich importiert. Zwei Ereignisgruppen wurden hinzugefügt: Dialoge und Shot-Wechsel.`)
};

const it_scene_description_import_success = /** @type {(inputs: Scene_Description_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizioni delle inquadrature importate correttamente. Sono stati aggiunti due gruppi di eventi: Dialoghi e Cambi di inquadratura.`)
};

const ru_scene_description_import_success = /** @type {(inputs: Scene_Description_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Описания кадров успешно импортированы. Добавлены две группы событий: Диалоги и Смена кадров.`)
};

const es_scene_description_import_success = /** @type {(inputs: Scene_Description_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las descripciones de las tomas se importaron correctamente. Se han añadido dos grupos de eventos: Diálogo y Cambios de toma.`)
};

const zh_cn2_scene_description_import_success = /** @type {(inputs: Scene_Description_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`镜头描述导入成功。已添加两个事件组：对话和镜头切换。`)
};

const ja_scene_description_import_success = /** @type {(inputs: Scene_Description_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショットの説明が正常にインポートされました。2つのイベントグループ（ダイアログとショット変更）が追加されました。`)
};

const hi_scene_description_import_success = /** @type {(inputs: Scene_Description_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉट विवरण सफलतापूर्वक आयात कर लिए गए हैं। दो इवेंट ग्रुप जोड़े गए हैं: संवाद और शॉट परिवर्तन।`)
};

const pt_pt2_scene_description_import_success = /** @type {(inputs: Scene_Description_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As descrições das cenas foram importadas com sucesso. Dois grupos de eventos foram adicionados: Diálogo e Mudanças de Cena.`)
};

/**
* | output |
* | --- |
* | "Shot descriptions imported successfully. Two Event Groups have been added: Dialogue and Shot Changes." |
*
* @param {Scene_Description_Import_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_description_import_success = /** @type {((inputs?: Scene_Description_Import_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Description_Import_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_scene_description_import_success(inputs)
	if (locale === "de") return de_scene_description_import_success(inputs)
	if (locale === "it") return it_scene_description_import_success(inputs)
	if (locale === "ru") return ru_scene_description_import_success(inputs)
	if (locale === "es") return es_scene_description_import_success(inputs)
	if (locale === "zh-CN") return zh_cn2_scene_description_import_success(inputs)
	if (locale === "ja") return ja_scene_description_import_success(inputs)
	if (locale === "hi") return hi_scene_description_import_success(inputs)
	if (locale === "pt-PT") return pt_pt2_scene_description_import_success(inputs)
	return en_scene_description_import_success(inputs)
});